import { useSession } from "./useSession.hook"

export function useIsAdmin() {
  const { user } = useSession();
  return user?.isAdmin?.() ?? false;
}